import { graphql } from "@/lib/gql/__generated__";

export const SendCustomMailSettingMutationForReservationCancel = graphql(/* GraphQL */ `
	mutation testCustomMailSendAtReservationCancel($input: CustomMailSettingTestMailInput!) {
		testCustomMailSendAtReservationCancel(input: $input) {
			userErrors
			success
		}
	}
`);
